import { Button, InputNumber } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const InputQuantity = ({
  value,
  onChange,
  isPlusDisabled = false,
}: {
  value: number;
  onChange: (value: number | null) => void;
  isPlusDisabled?: boolean;
}) => {
  return (
    <div className="d-flex align-items-center">
      <Button onClick={() => onChange(value - 1)} disabled={value === 0}>
        <MinusOutlined style={{ borderRadius: 0 }} />
      </Button>
      <InputNumber
        value={value}
        controls={false}
        onChange={onChange}
        style={{
          borderRadius: 0,
          width: '40px',
          textAlign: 'center',
          display: 'block',
          margin: 'auto',
        }}
      />
      <Button onClick={() => onChange(value + 1)} disabled={isPlusDisabled}>
        <PlusOutlined style={{ borderRadius: 0 }} />
      </Button>
    </div>
  );
};

export default InputQuantity;
